import { render, staticRenderFns } from "./tab8.vue?vue&type=template&id=0dabdd06"
import script from "./tab8.vue?vue&type=script&lang=js"
export * from "./tab8.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/Paldia/Paldia FE/FE-Paldia-Staging/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0dabdd06')) {
      api.createRecord('0dabdd06', component.options)
    } else {
      api.reload('0dabdd06', component.options)
    }
    module.hot.accept("./tab8.vue?vue&type=template&id=0dabdd06", function () {
      api.rerender('0dabdd06', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/require/components/tab8.vue"
export default component.exports